export default "__VITE_ASSET__4dfcf666__"